import { Group } from '@/api';
import { languageModule } from '@/store/languages';
import { ITableColumn } from '@/uikit/table/NTable.vue';
import NTableColumnCell from '@/uikit/table/NTableColumnCell.vue';
import ButtonModelCopy from '@/components/common/ButtonModelCopy.vue';
import GroupItem from './GroupItem.vue';

const t = languageModule.getTranslatedToken;

export const columns: ITableColumn[] = [
  {
    width: 'max-content',
    header: {
      classes: ['bottom-border'],
      component: NTableColumnCell,
      props: {
        i18n_label: 'common.id'
      }
    },
    content: {
      path: 'id',
      component: ButtonModelCopy
    }
  },
  {
    header: {
      classes: ['bottom-border'],
      component: NTableColumnCell,
      props: {
        i18n_label: 'common.name',
        name: 'name'
      }
    },
    content: {
      path: 'name',
      component: GroupItem,
      props: (item: Group) => ({ name: item.name })
    }
  }
];
